import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { columns, rows } from '../internals/data/fleetData';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

function generateExportFileName() {
  return "Battery-packs-" + dayjs().format('YYYY-MM-DD HH:mm:ss');
}

export default function FleetsDataGrid() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://0h5n8j55d5.execute-api.ap-south-1.amazonaws.com/dev/fleets/');
        const fleetsResponse = await response.json();
        const fleetsData = [];
        fleetsResponse.forEach((fleet, index) => {
          const fleetData = { id: index };
          Object.keys(fleet).forEach(key => {
            switch (key) {
              default:
                fleetData[key] = fleet[key];
            }
          });
          fleetsData.push(fleetData);
        });
        setData(fleetsData);
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleCellClick = (params) => {
    navigate(`/fleets/${params.row.fleet_id}`);
  };

  return (
    <DataGrid
      autoHeight
      checkboxSelection
      rows={data}
      columns={columns}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      initialState={{
        pagination: { paginationModel: { pageSize: 20 } },
      }}
      pageSizeOptions={[10, 20, 50]}
      onCellClick={handleCellClick}
      disableColumnResize
      density="compact"
      slots={{ toolbar: GridToolbar }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
        csvOptions: { fileName: generateExportFileName() },
        printOptions: { fileName: generateExportFileName(), hideToolbar: true, },
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: 'outlined',
                size: 'small',
              },
            },
          },
        },
      }}
    />
  );
}
